import * as forgotPassword from '../reducers/forgot-password/forgot-password.reducer';
import { createSelector } from '@ngrx/store';

export const getForgotPasswordCaptcha = createSelector(
  forgotPassword.getForgotPasswordState,
  forgotPassword.getForgotPasswordCaptcha
);

export const getForgotPasswordRequestLinkLoading = createSelector(
  forgotPassword.getForgotPasswordState,
  forgotPassword.getForgotPasswordRequestLinkLoading
);

export const getForgotPasswordRequestLinkSuccess = createSelector(
  forgotPassword.getForgotPasswordState,
  forgotPassword.getForgotPasswordRequestLinkSuccess
);

export const getForgotPasswordRequestLinkError = createSelector(
  forgotPassword.getForgotPasswordState,
  forgotPassword.getForgotPasswordRequestLinkError
);

export const getForgotPasswordRequestResetLoading = createSelector(
  forgotPassword.getForgotPasswordState,
  forgotPassword.getForgotPasswordRequestResetLoading
);

export const getForgotPasswordRequestResetSuccess = createSelector(
  forgotPassword.getForgotPasswordState,
  forgotPassword.getForgotPasswordRequestResetSuccess
);

export const getForgotPasswordRequestResetError = createSelector(
  forgotPassword.getForgotPasswordState,
  forgotPassword.getForgotPasswordRequestResetError
);
